let ajaxFormSuccess = new Event('growtypeFormAjaxFormSuccess');

export function ajaxFormSuccessEvent() {
    return ajaxFormSuccess;
}
